import React, { useState } from "react";
import ReactGA from "react-ga";
import { Heading } from "../Heading";
import InfoHeader from "./InfoHeader";
import NavbarTop from "./NavbarTop";

export default () => {
    const [collapse, setCollapse] = useState(false);
    const toggleCollapse = () => {
        setCollapse(!collapse);
        ReactGA.event({
            category: "Information",
            action: "Collapsed Info Header",
        });
    };
    return (
        <Heading>
            <InfoHeader isOpen={collapse} />
            <NavbarTop toggle={toggleCollapse} />
        </Heading>
    );
};
